/**
 * Which build is actually running — injected at build time by
 * `vite.config.ts`'s `define` (`__GIT_SHA__`/`__BUILD_TIME__`, computed via
 * `git rev-parse` when the config loads). Shown in Settings so a push to
 * `claude/design-sync-6s53x2` can be confirmed live on the server without
 * SSH-ing in — Coolify's auto-deploy has no other visible confirmation from
 * inside the app itself.
 */
export const BUILD_INFO = {
  gitSha: __GIT_SHA__,
  buildTime: __BUILD_TIME__,
};
